<template>
    <div>
        <b-modal ref="mdlExternalPrenotazioniPrenotaSlotModal" size="md" @shown="onShowModal" title="Seleziona Agenda e Box" centered scrollable no-close-on-backdrop :no-close-on-esc="true">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                        <label>Agenda</label>
                        <b-form-select v-model="form.idAgenda" class="mb-2 mr-sm-2 mb-sm-0" :options="agendaItemsOptions" :value="null" text-field="descrizione" value-field="id">
                            <template #first>
                                <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                        <label>BOX</label>
                        <b-form-select v-model="form.idBox" class="mb-2 mr-sm-2 mb-sm-0" :options="boxItemsOptions" :value="null" text-field="nome" value-field="id">
                            <template #first>
                                <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
            </b-form>
            <template #modal-footer>
                <b-button v-b-tooltip.hover size="md" variant="danger" title="Annulla" @click="onClickAnnulla()" class="mr-1 no-text">
                    <b-icon icon="book" variant="outline-sucess"></b-icon>
                    Annulla
                </b-button>
                <b-button v-b-tooltip.hover size="md" variant="info " title="Salva Prenotazione" @click="saveInAgenda()" :disabled="isSalvaPrenotazioneNotEnabled" class="mr-1 no-text">
                    <b-icon icon="book" variant="outline-sucess"></b-icon>
                    Prenota
                </b-button>
            </template>
        </b-modal>
        <modal-error ref="cmpModalError"> </modal-error>
    </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import AgendaMixin from "../../agende/agenda/mixins/AgendaMixin";
import BoxMixins from "../../agende/agendabox/mixins/BoxMixins";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
export default {
    components: { ModalError },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin, AgendaMixin, BoxMixins],
    data() {
        return {
            jsonData: {},
            pathResourceAgendaPrenotazioni: "/agendaappuntamenti",
            pathResourceExternalPrenotazione: "/externalprenotazioni",
            pathResourceAgendaBoxAccettazione: "/agendeboxaccettazione",
            appuntamento: {},
            form: {
                idAgenda: null,
                idBox: null,
            },
        };
    },
    computed: {
        isSalvaPrenotazioneNotEnabled() {
            if (this.form.idAgenda == null) {
                return true;
            }
            if (this.form.idBox == null) {
                return true;
            }
            return false;
        },
    },
    methods: {
        init(jsonData) {
            this.jsonData = jsonData;
            this.loadDataDefault();
            this.open();
        },

        loadDataDefault() {
            this.loadDataAgende();
            this.loadDataBox();
        },
        loadDataAgende() {
            this.agendeLoadData();
        },
        loadDataBox() {
            this.boxLoadData();
        },
        open() {
            this.$refs.mdlExternalPrenotazioniPrenotaSlotModal.show();
        },
        hide() {
            this.$refs.mdlExternalPrenotazioniPrenotaSlotModal.hide();
        },
        onSubmit() {
            this.saveInAgenda();
        },
        onShowModal() {
            this.form = {
                idAgenda: null,
                idBox: null,
            };
        },
        saveInAgenda() {
            let me = this;
            this.openShowModalLoading();
            UtilityMixin.methods.loadDataResources(me.pathResourceExternalPrenotazione + "/" + me.jsonData.contactId, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            let prenotazione = response.data.data;
            if (prenotazione.codiceFiscale === null && prenotazione.phone === null) {
                me.$refs.cmpModalError.show("Errore: non si può procedere perchè la prenotazione non ha nessun identificatico (Telefono/CodiceFiscale)", true);
            } else {
                let agendaAppuntamento = {
                    identificativoAppuntamento: prenotazione.codiceFiscale != null ? prenotazione.codiceFiscale : prenotazione.phone,
                    cognome: prenotazione.lastName,
                    nome: prenotazione.firstName,
                    dataOraInizio: me.jsonData.dataInizio,
                    costo: 0,
                    dataNascita: "",
                    dataOraFine: this.jsonData.dataFine,
                    dataRiferimento: this.formatDateTimeCustom(this.jsonData.dataInizio, "yyyy-MM-DD"),
                    descrizionePrestazione: "",
                    tipoIdentificativo: "CF",
                    id: me.jsonData.id,
                    primaryKey: me.jsonData.id,
                    dalleOre: this.formatDateTimeCustom(this.jsonData.dataInizio, "HH:mm"),
                    alleOre: this.formatDateTimeCustom(this.jsonData.dataFine, "HH:mm"),
                    idAgenda: this.form.idAgenda,
                    codicePrestazione: "",
                };

                UtilityMixin.methods.saveResource(me.pathResourceAgendaPrenotazioni, agendaAppuntamento, me.resultResponse, me.resultError);
            }
        },
        loadDataError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            this.closeShowModalLoading();
        },
        resultResponse(response) {
            this.salvaAgendaAccettazioneBox(response);
        },
        resultError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio, true);
            this.closeShowModalLoading();
        },
        salvaAgendaAccettazioneBox(response) {
            let me = this;
            let agendaAppuntamentoId = response.data.data.id;
            let boxAgendaAccettazione = {
                idAccettazione: agendaAppuntamentoId,
                idAppuntamento: agendaAppuntamentoId,
                idBox: me.form.idBox,
                dataOra: me.jsonData.dataInizio,
            };
            UtilityMixin.methods.saveResource(me.pathResourceAgendaBoxAccettazione, boxAgendaAccettazione, me.salvaAgendaAccettazioneBoxResponse, me.salvaAgendaAccettazioneBoxError);
        },
        salvaAgendaAccettazioneBoxResponse() {
            this.hide();
            this.$bvToast.toast("Appuntamento correttamente salvato", {
                title: "Operazione Avvenuta con successo",
                variant: "success",
                solid: true,
            });
            this.closeShowModalLoading();
        },
        salvaAgendaAccettazioneBoxError(error) {
            this.hide();
            let erroreMessaggio = "Errore non gestito";
            if (error.response.data.messaggio) {
                erroreMessaggio = error.response.data.messaggio;
            }
            this.$bvToast.toast(erroreMessaggio, {
                title: "Attenzione",
                variant: "danger",
                solid: true,
            });
            this.closeShowModalLoading();
        },
        onClickAnnulla() {
            this.form = {
                idAgenda: null,
                idBox: null,
            };
            this.hide();
        },
    },
};
</script>

<style scoped></style>
